import { createFileRoute } from "@tanstack/react-router";

import { Reveal } from "@/components/site/motion";
import { getDict, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/about")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.about.title} · insidermark` }, { name: "description", content: t.about.vision.body }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const a = t.about;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{a.title}</h1>
          </Reveal>
        </div>
      </header>

      <section className="im-section im-section--tight">
        <div className="im-wrap grid gap-12 md:grid-cols-2">
          <Reveal>
            <p className="im-mono">{a.vision.title}</p>
            <p className="im-display-sm mt-4">{a.vision.body}</p>
          </Reveal>
          <Reveal>
            <p className="im-mono">{a.mission.title}</p>
            <p className="im-body-text mt-4">{a.mission.body}</p>
          </Reveal>
        </div>
      </section>

      <section className="im-section">
        <div className="im-plate im-plate--manifest" aria-hidden="true" />
        <div className="im-wrap im-rel im-two">
          <Reveal>
            <h2 className="im-display-sm">{a.values.title}</h2>
          </Reveal>
          <ul className="im-list">
            {a.values.items.map((v) => (
              <li key={v.name}>
                <strong>{v.name}</strong>
                <span>{v.body}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="im-section im-section--tight">
        <div className="im-wrap im-two">
          <Reveal>
            <h2 className="im-display-sm">{a.notWeAre.title}</h2>
          </Reveal>
          <ol className="im-steps">
            {a.notWeAre.items.map((s) => (
              <li key={s}>
                <span>{s}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="im-section">
        <div className="im-wrap im-two">
          <Reveal>
            <h2 className="im-display-sm">{a.whyTurkiye.title}</h2>
          </Reveal>
          <div className="im-prose">
            {a.whyTurkiye.body.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="im-section im-section--tight">
        <div className="im-wrap im-two">
          <h2 className="im-display-sm">{a.team.title}</h2>
          <p className="im-body-text">{a.team.body}</p>
        </div>
      </section>
    </main>
  );
}
